import selectValueAndUnit from '@99designs/frontend-components/i18n/selectValueAndUnit';
import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';
import { FormattedRelativeTime, useIntl } from 'react-intl';

export type DateSource = number | Date | string;

export interface Props {
    date: DateSource;
}

const skeletonStyle: React.CSSProperties = {
    display: 'inline-block',
    width: '8ch',
    height: '1em',
    verticalAlign: 'text-bottom',
    borderRadius: '999px',
    backgroundColor: 'currentColor',
    opacity: 0.12,
};

function dateSourceToJSDate(date: DateSource): Date {
    if (typeof date === 'object') {
        return date as Date;
    }

    return new Date(date);
}

export default function RelativeTime({ date }: Props) {
    const intl = useIntl();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return <span aria-hidden="true" style={skeletonStyle} />;
    }

    const normalizedDate = dateSourceToJSDate(date);

    const dateTime = DateTime.fromJSDate(normalizedDate).setLocale(intl.locale);

    const durationFromNow = dateTime.diffNow();
    const [value, unit] = selectValueAndUnit(durationFromNow);

    const title = dateTime.toFormat('ccc, LLL d, yyyy, HH:mm ZZZZ');

    return (
        <span title={title}>
            <FormattedRelativeTime value={Math.round(value)} unit={unit} numeric="auto" />
        </span>
    );
}
